const LoadingIndicator = () => {
  return (
    <div className="h-full w-full flex justify-center items-center bg-primary/10">
      <span className="loading loading-infinity bg-secondary loading-lg"></span>
    </div>
  );
};

export default LoadingIndicator;
